import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=7cbfaa14&"
import script from "./splash.vue?vue&type=script&lang=js&"
export * from "./splash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports